var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectors1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 852,
    height: 852,
    viewBox: "0 0 852 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M823.127 424.862C823.127 477.111 812.836 528.847 792.842 577.118C772.847 625.389 743.541 669.249 706.596 706.194C669.651 743.139 625.791 772.445 577.52 792.439C529.249 812.434 477.513 822.725 425.265 822.725C373.017 822.725 321.28 812.434 273.009 792.439C224.739 772.445 180.878 743.139 143.934 706.194C106.989 669.249 77.6823 625.389 57.6878 577.118C37.6934 528.847 27.4023 477.11 27.4023 424.862L823.127 424.862Z",
    fill: "url(#paint0_linear_61_33)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M823.127 425.138C823.127 372.889 812.836 321.153 792.842 272.882C772.847 224.611 743.541 180.751 706.596 143.806C669.651 106.861 625.791 77.555 577.52 57.5606C529.249 37.5661 477.513 27.2751 425.265 27.2751C373.017 27.2751 321.28 37.5661 273.009 57.5606C224.739 77.555 180.878 106.861 143.934 143.806C106.989 180.751 77.6823 224.611 57.6878 272.882C37.6934 321.153 27.4023 372.89 27.4023 425.138L823.127 425.138Z",
    fill: "url(#paint1_linear_61_33)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_33",
    x1: 424.776,
    y1: 76.3236,
    x2: 699.776,
    y2: 425.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_33",
    x1: 424.776,
    y1: 76.3236,
    x2: 699.776,
    y2: 425.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectors1);
export default __webpack_public_path__ + "static/media/sectors-1.4535001ea470bea96b6b5df27b10aa6d.svg";
export { ForwardRef as ReactComponent };